import { useAppDispatch, useAppSelector } from '../store/hooks';
import { Filter } from './Filter';
import { fromCamelCaseToWords } from '../misc/functions';
import { COLUMNS } from '../misc/columns.constants';
import { resetFilters } from '../features/table/table.actions';

export function Filters() {
  const dispatch = useAppDispatch();
  const websitesData = useAppSelector((state) => state.table.websitesData);
  const columns = websitesData?.columns ?? [];

  if (!websitesData || websitesData.websites.length === 0) {
    return null;
  }

  function onResetFilters() {
    dispatch(resetFilters());
  }

  return (
    <div className="filters">
      <div className="flex-column">
        <button
          className="btn btn--danger"
          onClick={onResetFilters}
          data-qa="resetFilters"
        >
          reset filters
        </button>

        {columns.map((col) => {
          if (!col.renderFilter || col.name === COLUMNS.tags) {
            return null;
          }

          return (
            <Filter
              key={col.name}
              name={col.name}
              placeholder={fromCamelCaseToWords(col.name)}
            />
          );
        })}
      </div>
    </div>
  );
}
